import QrCodeIcon from "@mui/icons-material/QrCode";
import { Box } from "@mui/material";
import { ButtonLink } from "Components/Shared/ButtonLink";
import { Resources, useResource } from "Translations/Resources";
import { appUrl } from "Utils/UrlUtils";

const COMPONENT_RESOURCES =
  Resources.Components.Transactions.TransactionPaymentOptions;

type Props = {
  transactionPublicID: string;
  isDisabled?: boolean;
  isDirectPaymentHidden?: boolean;
};

export const TransactionPaymentOptions = ({
  transactionPublicID,
  isDirectPaymentHidden,
  isDisabled,
}: Props) => {
  const { t } = useResource();

  return (
    <Box display="flex" flexDirection="row" width="100%" gap={4}>
      {!isDirectPaymentHidden && (
        <ButtonLink
          color="primary"
          variant="contained"
          disabled={isDisabled}
          link={`${appUrl("customer-payment-pay")}/${transactionPublicID}`}
          text={t(COMPONENT_RESOURCES.DirectPaymentButton)}
        />
      )}
      <ButtonLink
        color="info"
        variant="outlined"
        disabled={isDisabled}
        link={`${appUrl("initiate-qr-payment")}/${transactionPublicID}`}
        text={t(COMPONENT_RESOURCES.ShowPaymentDataButton)}
        endIcon={<QrCodeIcon />}
      />
    </Box>
  );
};
